import styled from "styled-components";
import theme from "../../../assets/theme";

export const Grid = styled.div`
  @media ${theme?.breakpoints?.sm_up} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
  }
`;
